import React from 'react'

import ChartMarketAffect from '../chart/chartMarketAffect'
import ChartMarketCapitalization from '../chart/chartMarketCapitalization'
import ChartMarketLiquid from '../chart/chartMarketLiquid'
import ChartMarketTradeVol from '../chart/chartMarketTradeVol'

import { ImInfo } from 'react-icons/im'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { log } from 'utils'
import { connect } from 'react-redux'
import * as _ from 'lodash'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function TabThiTruong(props) {
  const [topAnhHuong, setTopAnhHuong] = React.useState(null)
  const [thanhKhoan, setThanhKhoan] = React.useState(null)
  const [tangGiam, setTangGiam] = React.useState(null)
  const [vonHoa, setVonHoa] = React.useState(null)
  const [intervalId, setIntervalId] = React.useState(null)

  const { marketActive, typeOrder, t, theme, algoCache } = props

  const preAlgoCache = usePrevious(algoCache)

  const abortController = new AbortController()

  React.useEffect(() => {
    return () => {
      abortController.abort()
      if (intervalId) clearInterval(intervalId)
    }
  }, [])

  React.useEffect(() => {
    if(algoCache && !_.isEqual(algoCache, preAlgoCache)){
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'CONTRIB_RETURN' ){
        setTopAnhHuong(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'MARKET_TOTAL_VALUE' ){
        setThanhKhoan(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'SEC_VALUE' ){
        setTangGiam(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'MARKET_CAP' ){
        setVonHoa(algoCache?.DATA)
      }
    }
  }, [algoCache])

  React.useEffect(() => {
    let _intervalId
    if (marketActive) {
      if (intervalId) clearInterval(intervalId)

      loadTopAnhHuong()
      loadThanhKhoan()
      loadTangGiam()
      loadVonHoa()

      // _intervalId = setInterval(() => {
      //   loadTopAnhHuong()
      //   loadThanhKhoan()
      //   loadTangGiam()
      //   loadVonHoa()
      // }, 10 * 1000)

      // setIntervalId(_intervalId)
    }
    return () => {
      if (_intervalId) clearInterval(_intervalId)
    }
  }, [marketActive])

  function loadTopAnhHuong() {
    fetch(appUrl + 'pbapi/api/Contrib?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setTopAnhHuong(res)
      })
      .catch((error) => {
        log(error)
      })
  }

  function loadThanhKhoan() {
    fetch(appUrl + 'pbapi/api/MarketValue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setThanhKhoan(res)
      })
      .catch((error) => {
        log(error)
      })
  }

  function loadTangGiam() {
    fetch(appUrl + 'pbapi/api/TotalValue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setTangGiam(res)
      })
      .catch((error) => {
        log(error)
      })
  }

  function loadVonHoa() {
    fetch(appUrl + 'pbapi/api/MarketCap?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setVonHoa(res)
      })
      .catch((error) => {
        log(error)
      })
  }

  console.log(marketActive, typeOrder, algoCache, )

  return (
    <div
      className="d-grid w-100 h-100"
      style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '15px' }}
    >
      <div
        className="w-100"
        style={{
          background: theme === 'light' ? '#f9f9f9' : '#110E1E',
          borderRadius: '4px',
        }}
      >
        <p
          className="mb-0 text-white text-uppercase fz-14 fw-500 d-flex align-items-center justify-content-center"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-contribution-index')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.top-anh-huong')} {topAnhHuong?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketAffect topAnhHuong={topAnhHuong} t={t} theme={theme} />
        </div>
      </div>
      <div
        className="w-100"
        style={{
          background: theme === 'light' ? '#f9f9f9' : '#110E1E',
          borderRadius: '4px',
        }}
      >
        <p
          className="mb-0 text-white text-uppercase fz-14 fw-500 d-flex align-items-center justify-content-center"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-trading-volume')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.kl-giao-dich')} {tangGiam?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketTradeVol tangGiam={tangGiam} typeOrder={typeOrder} />
        </div>
      </div>
      <div
        className="w-100"
        style={{
          background: theme === 'light' ? '#f9f9f9' : '#110E1E',
          borderRadius: '4px',
        }}
      >
        <p
          className="mb-0 text-white text-uppercase fz-14 fw-500 d-flex align-items-center justify-content-center"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Liquidity')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.thanh-khoan')} {thanhKhoan?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketLiquid
            thanhKhoan={thanhKhoan}
            typeOrder={typeOrder}
            t={t}
            theme={theme}
          />
        </div>
      </div>
      <div
        className="w-100"
        style={{
          background: theme === 'light' ? '#f9f9f9' : '#110E1E',
          borderRadius: '4px',
        }}
      >
        <p
          className="mb-0 text-white text-uppercase fz-14 fw-500 d-flex align-items-center justify-content-center"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-market-capitalization')}{' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.bieu-do-von-hoa')} {vonHoa?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketCapitalization vonHoa={vonHoa} />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    algoCache: state.socket.algoCache,
  }
}

export default connect(mapStateToProps)(TabThiTruong)
